<div fxLayout="column" fxFlex=60>
  <br />
  <h1 class="mat-headline" style="border-bottom: 1px solid #b3b2b2;font-size: 39px;">Lelystad Open Data</h1>
</div>